import './index.erb';
import './index.rb';
import s from './index.module.scss';

class SearchBar {
  constructor() {
    this.init();
  }

  init() {
    this.clearButton = $(`.${s.clearSearch}`);
    this.searchButton = $(`.${s.btnSearch}`);

    this.configureInputActions();
    this.updateView();
  }

  configureInputActions() {
    this.inputText = $('#search-study-guide');

    const [input] = this.inputText;

    this.inputSearch = input.value;
    this.inputMinLength = input.minLength;

    this.inputText.on('change paste input', e => {
      this.inputSearch = e.currentTarget.value;
      this.updateView();
    });

    this.clearButton.on('click', () => {
      this.clearSearch();
      this.updateView();

      if (this.hasSearchParams()) {
        this.updateLocation();
        document.activeElement?.blur();
        return;
      }

      this.inputText.focus();
    });
  }

  isValidSearch() {
    return String(this.inputSearch).trim().length >= this.inputMinLength;
  }

  hasSearchParams() {
    const url = new URL(window.location.href);
    return url.search.length > 0;
  }

  clearSearch() {
    this.inputText.val('');
    this.inputSearch = '';
  }

  updateView() {
    this.updateClearButton();
    this.updateSearchButton();
  }

  updateLocation() {
    const url = new URL(window.location.href);
    Turbolinks.visit(url.origin + url.pathname, { action: 'replace' });
  }

  updateClearButton() {
    if (this.isValidSearch()) {
      this.clearButton.show();
      return;
    }
    this.clearButton.hide();
  }

  updateSearchButton() {
    if (this.isValidSearch()) {
      this.searchButton.prop('disabled', false);
      return;
    }
    this.searchButton.prop('disabled', true);
  }
}

(() => {
  new SearchBar();
})();
